/**
 * @generated SignedSource<<4fec987cb83538f5f89e3acf9e28c55d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueResults_viewResult$data = {
  readonly __typename: "QueryError";
  readonly extensions?: ReadonlyArray<{
    readonly statusCode: number | null | undefined;
  }> | null | undefined;
  readonly message?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_DetailView_view" | "main_issueNavigator_ListView_view">;
  readonly " $fragmentType": "main_issueNavigator_IssueResults_viewResult";
};
export type main_issueNavigator_IssueResults_viewResult$key = {
  readonly " $data"?: main_issueNavigator_IssueResults_viewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueResults_viewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueResults_viewResult",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "main_issueNavigator_ListView_view"
        },
        {
          "kind": "FragmentSpread",
          "name": "main_issueNavigator_DetailView_view"
        }
      ],
      "type": "JiraIssueSearchView"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "message"
        },
        {
          "kind": "LinkedField",
          "name": "extensions",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "statusCode"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ],
      "type": "QueryError"
    }
  ],
  "type": "JiraIssueSearchViewResult",
  "abstractKey": "__isJiraIssueSearchViewResult"
};

(node as any).hash = "c62e6e48eccad98fb8d9de957a0d79e9";

export default node;
